<template>
  <div class="evaluation-reviewed">
    <div class="search_box">

      <div class="item">
        <span class="itemtitle">审核结果</span>
        <el-select v-model="reviewedForm.status"
                   clearable
                   @change="search"
                   size="small"
                   style="width:180px">
          <el-option label="全部"
                     :value="3"></el-option>
          <el-option label="审核通过"
                     :value="1"></el-option>
          <el-option label="审核不通过"
                     :value="2"></el-option>

        </el-select>
      </div>

      <div class="item">
        <span class="itemtitle">评价用户</span>
        <el-input v-model="reviewedForm.keyword"
                  clearable
                  style="width:200px"
                  size="small"
                  maxlength="20"
                  placeholder="请输入用户名称或手机号"
                  @change="search"></el-input>
      </div>

      <div class="item">
        <span class="itemtitle">评价时间</span>
        <el-date-picker v-model="reviewedForm.create_time"
                        type="daterange"
                        align="right"
                        size="small"
                        unlink-panels
                        value-format="yyyy-MM-dd"
                        range-separator="~"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        style="width:230px"
                        @change="search">
        </el-date-picker>
      </div>

      <div class="item">
        <span class="itemtitle">综合评分</span>
        <el-select v-model="reviewedForm.evaluate"
                   clearable
                   size="small"
                   @change="search"
                   style="width:180px">
          <el-option label="1"
                     :value="1"></el-option>
          <el-option label="2"
                     :value="2"></el-option>
          <el-option label="3"
                     :value="3"></el-option>
          <el-option label="4"
                     :value="4"></el-option>
          <el-option label="5"
                     :value="5"></el-option>
        </el-select>
      </div>

      <div class="item">
        <span class="itemtitle">审核时间</span>
        <el-date-picker v-model="reviewedForm.examine_time"
                        type="daterange"
                        align="right"
                        size="small"
                        unlink-panels
                        value-format="yyyy-MM-dd"
                        range-separator="~"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        style="width:230px"
                        @change="search">
        </el-date-picker>
        <el-button type="primary"
                   style="margin-left:20px"
                   size="small"
                   @click="search">查询</el-button>
        <el-button size="small"
                   @click="restBtn">重置</el-button>
      </div>

    </div>
    <div style="border: solid 1px #c9cbd6;">
      <el-table v-loading="tableLoading"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }">
        <el-table-column v-for="(item) in tableHeader"
                         :key="item.prop"
                         :prop="item.prop"
                         :label="item.label"
                         :width="item.width"
                         :align="item.align"
                         :fixed="item.fixed">
          <template slot-scope="scope">
            <div v-if="item.prop == 'number'">
              {{ scope.$index+1 }}
            </div>
            <div v-else-if="item.prop == 'order_sn'">
              <el-link type="primary"
                       :disabled=" module_id_array[0] ? !module_id_array.includes('788') : false"
                       @click="toDetails(scope.row)"> {{ scope.row.order_sn}}</el-link>
            </div>
            <div v-else-if="item.prop == 'nick_name'">
              {{ scope.row.nick_name}}({{ scope.row.phone }})
            </div>
            <div v-else-if="item.prop == 'create_time'">
              {{ scope.row[item.prop] | dateFormat }}
            </div>
            <div v-else-if="item.prop == 'examine_time'">
              {{ scope.row[item.prop] | dateFormat }}
            </div>
            <div v-else-if="item.prop == 'status'">
              {{ scope.row[item.prop] | statusText }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       size="medium"
                       :disabled=" module_id_array[0] ? !module_id_array.includes('1465') : false"
                       @click="lookDetail(scope.row.ev_id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <pagination v-show="totalNum>0"
                :total="totalNum"
                :page.sync="pagination.page"
                :limit.sync="pagination.pageNumber"
                @pagination="getList" />
    <!-- 评价详情 -->
    <details-dialog :detailsDia.sync="detailsDia"
                    :info="detailsInfo"
                    :is_audit="1"></details-dialog>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import shoppingmall from '@/api/shoppingmall.js';
import Pagination from '@/components/Pagination/index';
import DetailsDialog from '../components/detailsDialog.vue';
export default {
  components: {
    Pagination,
    DetailsDialog
  },
  data() {
    return {
      tableLoading: false,
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      reviewedForm: {
        status: 3,
        keyword: '',
        create_time: '',
        evaluate: '',
        examine_time: ''
      },
      tableHeader: [
        {
          label: '序号',
          prop: 'number',
          width: '50',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '订单号',
          prop: 'order_sn',
          width: '160',
          align: 'center',
          fixed: false
        },
        {
          label: '评价用户',
          prop: 'nick_name',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '综合评分',
          prop: 'evaluate',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '评价时间',
          prop: 'create_time',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '审核时间',
          prop: 'examine_time',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '审核结果',
          prop: 'status',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      tableData: [],
      detailsDia: false,
      detailsInfo: {}
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    statusText(val) {
      switch (val) {
        case 0:
          return '待审核';
        case 1:
          return '审核通过';
        case 2:
          return '审核不通过';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.reviewedForm, this.pagination);
      params = _.omit(params, ['create_time', 'examine_time']);
      params.status = params.status == '' ? 3 : params.status;
      if (
        this.reviewedForm.create_time &&
        this.reviewedForm.create_time.length
      ) {
        params.start_create_time = this.reviewedForm.create_time[0];
        params.end_create_time = this.reviewedForm.create_time[1];
      }
      if (
        this.reviewedForm.examine_time &&
        this.reviewedForm.examine_time.length
      ) {
        params.start_examine_time = this.reviewedForm.examine_time[0];
        params.end_examine_time = this.reviewedForm.examine_time[1];
      }

      this.tableLoading = true;
      shoppingmall.getSelfUserOrderEvaluateList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    restBtn() {
      this.reviewedForm = {
        status: 3,
        keyword: '',
        create_time: '',
        evaluate: '',
        examine_time: ''
      };
      this.pagination.page = 1;
      this.pagination.pageNumber = 10;
      this.getList();
    },
    lookDetail(ev_id) {
      const loading = this.$loading();
      shoppingmall
        .getUserOrderEvaluateInfo({ ev_id })
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.detailsInfo = data.info;
            this.detailsDia = true;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    toDetails(row) {
      let { order_id } = row;
      this.$router.push({
        path: '/home/shoppingmall/orderdetail',
        query: {
          order_id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped >
.evaluation-reviewed {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  .search_box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      .itemtitle {
        display: inline-block;
        width: 80px;
        margin-right: 8px;
        text-align: right;
      }
    }
  }
}
</style>